import { packageInfo } from '@/config/package-info'
import { useSidebar } from './ui/sidebar'
export default function AppVersion() {
  const { state } = useSidebar()
  const environment = import.meta.env.MODE === 'staging' ? 'dev.' : ''
  return (
    <p className="text-gray-500 text-xs">
      {state === 'collapsed' ? '' : 'Versão:'} {environment}
      {packageInfo.version}
    </p>
  )
}
